import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '@repo/utils/types';
import { apiObservable } from '@repo/utils/helpers/api';
import AppState from '../../reducers/app-state';

/* Epic actions */
const sharedGroupActions = requestActions('SHARED_GROUP', ['fetch']);

/* Component actions */
export const fetchSharedGroup = (groupUUID: ID, user: UserSession | null) =>
  sharedGroupActions['fetch']({ groupUUID, authenticatedUser: !!user });

export const fetchSharedGroupEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_SHARED_GROUP'),
    mergeMap(({ payload }) =>
      apiObservable('GET', `/shared-group/${payload.groupUUID}/`, undefined, {
        apiVersion: 'v2',
        noAuthorization: !payload.authenticatedUser,
      }).pipe(
        map(({ response }) =>
          sharedGroupActions['fetchSucceeded']({
            ...response,
            groupUUID: payload.groupUUID,
          }),
        ),
        startWith(sharedGroupActions['fetchRequested']({ groupUUID: payload.groupUUID })),
        catchError((error) =>
          of(
            sharedGroupActions['fetchFailed']({
              error,
              groupUUID: payload.groupUUID,
            }),
          ),
        ),
      ),
    ),
  );

export const sharedGroupsEpic = combineEpics<ReduxAction, any, AppState>(fetchSharedGroupEpic);
